
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mainl1oJ3SknrtRhqbZZqzs4VqYAasRPWD7OCMNboDDgs1AMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/main.vue?macro=true";
import { default as guide7pKS2x0oLerQplRoIMka1KO8A9m2Jc0QyOW9sQj1cwMMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guide.vue?macro=true";
import { default as indexKJ0ei3poj_K5C0j24BEYSu9W64cxJUdtuIlsvrzbpUAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/index.vue?macro=true";
import { default as sampleOeeJbLosjmgnBDYdOVKEvGXSI9p5qydUG_G4oRjzQQQMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/sample.vue?macro=true";
import { default as pinWEmdZv_eiCzR0rzSki0uRWGVtF19mTpYGl1gpnOlbpwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/pin.vue?macro=true";
import { default as pinSagMlPsgKk4qBID6zTcYnd1FQFAjiYz_zEj8GmtQDlQMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/pin.vue?macro=true";
import { default as home_45free4rqqNhPa92cCEMElgctUW3j4g3PB5H3ZwjCyG_jljFcMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/home-free.vue?macro=true";
import { default as linkI35rc2NvFWfmJ5uhEE7i9ULQpd7v5m7SzmIvu3cAEBUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/host/link.vue?macro=true";
import { default as planGm9vgvqaQ_Qytu3i93GXFCc5WZMcbyOe0vvntAdM3dYMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/plan.vue?macro=true";
import { default as addRJk0boWBi9BplpBlvAljSA7KThDzhpY1zWE_cdD43oIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/add.vue?macro=true";
import { default as link_DcU9fVaIYG3zLnCRD6pvydUxgSWC_AlrwzJS7dRuSQMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/link.vue?macro=true";
import { default as indexgXnBpYm0cMdkUG3gNMyYuTO9SAQ8a5oOGHFk_hWCaPYMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/index.vue?macro=true";
import { default as terms2QJhWDzMHOC_JnUG4ZjvgBg5mHswEI6tY_aU1TdUiosMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/terms.vue?macro=true";
import { default as indexPD2FuBVYkhXYj6A1sXwD1c2xrlL242KOrnHq2JCFiG0Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/index.vue?macro=true";
import { default as verify3MnbpkILLivSD6GyDW0or3wEdgfuUhRNFcNfwbwCX8gMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/verify.vue?macro=true";
import { default as lock_45screenXWasmKWRIkbbm1sr4DjGjCKDeBhPJo2iVV3rBrIvjuAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/lock-screen.vue?macro=true";
import { default as indexevi2pxKdpxOJMHoEu3e_xiK3aUA03bt5lsN1srzmo_oMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/login/index.vue?macro=true";
import { default as index6XuNAq_4Yb2RXweE_3RrKh_tsgozUTVE_5cp__vWRpAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/index.vue?macro=true";
import { default as sirennqauH_1_TXGX1l2QB9d76L_1VrdVJnF3TSQVcft_FWoMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/siren.vue?macro=true";
import { default as indexZpqw9ieO8tYKUYx4_Me_VZNCQPoMhFFG6jNPh68HC48Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/index.vue?macro=true";
import { default as captcha3UAegGqlkBl0xPycBT_Dw5AjYKE2u33tjgswk0xd4zYMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/captcha.vue?macro=true";
import { default as emailJtQmVydrBBgx82hwMpS5RpT2bs3HIg4xGS0_G5A9kAgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/email.vue?macro=true";
import { default as indexlQsVrmghc_JwGaa91zgKrkSrRnvkgNoACJDi6jmLUz8Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/index.vue?macro=true";
import { default as block_45serviceHlJ7qJKR1J1LpP8UqRtef09Tp6HYR2W5r97Uoe_xVyUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/block-service.vue?macro=true";
import { default as _91_91telco_93_93gjkt8hVvgH73iE5nRpsGg2ylUGplt9_TF7WafGDIbWwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/bye/[[telco]].vue?macro=true";
import { default as completeEbMFu7oeX4NkoEIYbGNntuUMBchKmtr2QZWPXFrNy0AMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/complete.vue?macro=true";
import { default as captcha6Us0gyrGgx1J80l8ISHgN193XVQ_6NqGtZ_v_V8PosAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/login/captcha.vue?macro=true";
import { default as listcgc9hgcUdXO0hZcVtwx2PAwl31WXK3F0bqTgMQ45rP0Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/list.vue?macro=true";
import { default as reportwqO8xwKijbK62ykaRbwVnI_GDSXDfwMd73Tid7KDXhQMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/report.vue?macro=true";
import { default as privacyPolicyr9MqsbP2Z3B7y51btfpGomUm3aSp3qne2eAgLOvC204Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/privacyPolicy.vue?macro=true";
import { default as indexzwMCAx1Wy_gVDt_7nDatFWcLD5Crwhu3lP3i57Yow1MMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/index.vue?macro=true";
import { default as loginNQdrJ_fi7wFVNHNU9W2FZMwotklanC1TZ2jySF5GudoMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/login.vue?macro=true";
import { default as cert_45popupc5oU00VovzKFSFR0GR7fohsTpFvljfIy10Rrlm3VBmEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/kcb/cert-popup.vue?macro=true";
import { default as inquiry5LSSuHHbcXnCqIxQY4L6zjBuQtJJTiVh3H87nC23QMgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/inquiry.vue?macro=true";
import { default as locationZdYGEausF5QkXna1jyTD7m1twuSBmtdfYceGYMeONwUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/location.vue?macro=true";
import { default as permissionzwW8_2CM_fxdgjtvA2mgSrACSh7drbpdZtEg4E6zDcwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/permission.vue?macro=true";
import { default as policiesL8e_F0nCXyZTdVNyaYrIElizmN6nmqbo2I_xNWlqYwwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/policies.vue?macro=true";
import { default as permissionMVGXPgnHRRERyKylcj_vdWr2vhgLd5vPfr1OXIdW37YMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/permission.vue?macro=true";
import { default as accountrn562ToSv4an3wJ2o8VBJpGZ4Mpdw2_tK_4uwa38f3oMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account.vue?macro=true";
import { default as couponsjPSRfEOJMCzXNd32rbo1ZTR0oWw_s1_aJduUbvTaPBAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/coupons.vue?macro=true";
import { default as signup_45freeidP2o1S9EAbhSJ9qPUIUQH6z_t8a_Yx5Ykku_yQvCR0Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/signup-free.vue?macro=true";
import { default as sns_45connectPOAVVvKbseipBDiDHV7_Kt9maDemwjPyvdKqKkd9LnEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/sns-connect.vue?macro=true";
import { default as terms_45agreerm_FO5lL8usF4Nz8QpyhJAAaWR3Qo9hkcAfgqXPmD4QMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/terms-agree.vue?macro=true";
import { default as line_45info_KoDhMD4fHZRCzzIYxIwf4z7T_42aNuusN9_VFNOKywMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/line-info.vue?macro=true";
import { default as _91_91telco_93_93KE3blRWs_aOwqoCM1R3BNJgcTwjPJ_3qkK__I18musIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/refund/[[telco]].vue?macro=true";
import { default as block_45appsQcygcsY7vXABFJaWsrDZMCtqdHg77YFaHK4Ka9686r4Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/block-apps.vue?macro=true";
import { default as invite_45codenvQ11x9SSsZqSJet_yP0jwgPMeZjUOdTrgkFCZ9DYi8Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/invite-code.vue?macro=true";
import { default as magazineJi29TPOsc7z0HpXbU54LILDaDqYuTELFefGF1COfL5MMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/magazine.vue?macro=true";
import { default as cert_45callbackjo2PcjvW4VK6E2R1Lo9IZJG6v2VHZ3mrE_j_3x3_VOIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/kcb/cert-callback.vue?macro=true";
import { default as loss_45statusy1lye7WrYKgUNtD9NA4sDwLC0UBD0kG_kXESlAXyJPAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/loss-status.vue?macro=true";
import { default as service_45introgZREWFNXG1_jmZ2D96fAPFCCY3wLxoQUJ3Us14ADsYgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/service-intro.vue?macro=true";
import { default as callback2Geex_vik7B1bnzmXK6jWhwtjnPxVeCL9heJJ97UZOwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/apple/callback.vue?macro=true";
import { default as callbackx_3X9bMQPQLzBE8Gdzo_RAwi_cU7VnBPpM9HPdwz4WUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/kakao/callback.vue?macro=true";
import { default as callbackOzAMCpH7lDF55Ks6b1xxtyUyNUqML6hz2HjpS9uKrzEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/naver/callback.vue?macro=true";
import { default as lock_45messageNNz5bDcnQ2WIxJe1nLyjjH7aFunN4MT3QYlsSEgQ8k8Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/lock-message.vue?macro=true";
import { default as usim_45historyKFz32J9KFyb73kTsfoig7_UhVeZWeoZXsGfA0_5O12QMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/usim-history.vue?macro=true";
import { default as find_45phonehklgui7yRKATh63lbawbJ9K52_1IQq8ZDM5L3FM8NCgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/find-phone.vue?macro=true";
import { default as indexK4L2EdB7kSzwyDnJf87vOhXQPQ1BfYnpCNZ2kRGQfPAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/cancel/index.vue?macro=true";
import { default as callbackKzujLD6k8b68zMHkLeo_Q__vQJ6nl9p_vJs1t_zKHJEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/google/callback.vue?macro=true";
import { default as email_45loginmBzD4Tk1XJe9Y_BqYAIoK4bVMWVfiJIAZuECh99hgmoMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/email-login.vue?macro=true";
import { default as sns_45connectCp7lzI5D62LKfiEwkP99ViswDL4Y4mkxLXSYPNyeZ4cMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/sns-connect.vue?macro=true";
import { default as terms_45agreeAFieluV1UOevBGrygs_KdtgA6SN5tF87hC5PAycNmCcMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/terms-agree.vue?macro=true";
import { default as indexdIYm5G25sfOhv0_QFj2nZi55gkKRGpHkFDLQIZ601ggMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupons/index.vue?macro=true";
import { default as phone_45verifyJqhdT9g9HIhLEWxywkKm9gv_A9pjruhXJU3c1u_sE2IMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/phone-verify.vue?macro=true";
import { default as formetWhqedD9zi_AFUn2UyILc5jD7izghS1tcvDml6ZLnwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/form.vue?macro=true";
import { default as message_45history6A4g5N8RZzUjSNdQLHqDbme7y7ffGy_bB7UnNdHUKZIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/message-history.vue?macro=true";
import { default as completeODbjsDMLYEWmaV1Y1CKaR_wOxUUsqHQXfCgjhK0ie48Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/cancel/complete.vue?macro=true";
import { default as filesFkza0ow7WSbrLyHy2JGd4Jm1SG0dDD_tVZur6bGZPzIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/files.vue?macro=true";
import { default as guideAjr7uIqKREttVp2d_pzFHTVc5b0NvSNV6NQXCOYJq5UMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/guide.vue?macro=true";
import { default as indexxUzLw9WXDg_JVR39YqtcFNcev_CJV2X281ZkXgEEPCMMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/index.vue?macro=true";
import { default as editNoRoXLem9dOUSabGUSkTSLxVEioms3srYDYVMvuizS8Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/edit.vue?macro=true";
import { default as service_45signupSErrstl7knZNgGbPiDLyocLqcgGPVCAwAcICn3e4dcIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/service-signup.vue?macro=true";
import { default as detailGShdAFTMbbxYK3Jx8JDBlf_ewxXQZhzd_9wTUocyX2gMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/detail.vue?macro=true";
import { default as reviewH9fhmOCl0RGwaXWsfsx1u0eyX_XW9R_A9V2gBhtp_FQMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/review.vue?macro=true";
import { default as emergency_45contactna_od4IMnDpjb3XFhfKcHoClx0zVsesja9Ntj2mKPGgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/emergency-contact.vue?macro=true";
import { default as indexfjUYjh3ttwWJB_mEOzVAKlOu_QxZCDLQRCcG002YlLUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/index.vue?macro=true";
import { default as sirenOlUb5tEPJLRhkFXPXjrJxHPr5_x0wLu1eD5LrCOFCEUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/siren.vue?macro=true";
import { default as signup_45completexJJdn1T1DcHDBFuVCsPvCD9galNGPKdVoxrkCstybaAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/signup-complete.vue?macro=true";
import { default as accessibility_45guidezq8uJ_b8_ofCB4_Abb9RIWGhpA7iTM_7nna_8MPcemwMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/accessibility-guide.vue?macro=true";
import { default as historyiSP_02xyuLEfH5TQF_3fsIcELMYGg8T77bQV7v3gt5kMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/history.vue?macro=true";
import { default as accessibility_45guide_ptTayoqW8a3OqKrBWEJCGTRRQV4ZF_yuIx__3J0UpEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/accessibility-guide.vue?macro=true";
import { default as insurance_45claimsjHcX9iwLj_lQiMOdMSDM1rJ7LULmOqQkAw5dXMlIiyEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/insurance-claims.vue?macro=true";
import { default as financial_45detail029EL3_JK64cmDCImsnjl0Hf3mwU7PWw44xRPNsCx4cMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/financial-detail.vue?macro=true";
import { default as complete1YtCSNmKXQJ35NspI_MGZD5Kzzqem0Kah740c_7bUUgMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/complete.vue?macro=true";
import { default as block_45apps_45completeGXcD9lPyvEkKY3lnpIXsVVQCI21MoTz18qvrYMwkQmsMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/block-apps-complete.vue?macro=true";
import { default as family_45protectiontfgQ3YiXHUepREZF8eIF7Ns7bGgvP1OWPtw3UIWl9e0Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/family-protection.vue?macro=true";
import { default as _91couponIdx_93rhrTol38rbO3sWROXQ6MGDQgSUJe5MsPwncfVugHec0Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupons/[couponIdx].vue?macro=true";
import { default as emergency_45contactsVaE62QmkVYlYZserxyP7txGXiwRnhx4TsFf4mzOrgGAMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/emergency-contacts.vue?macro=true";
import { default as financial_45magazinefoxpNnEB2fMMpw1z0YQc7_x7YC1i8QziaQ4kGcQz5CIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/financial-magazine.vue?macro=true";
import { default as _91idx_93_JeX92TsNlQ2BJb2ZFD1XeH1EXyMBT1aa6__3camCcIMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/customer-center/[idx].vue?macro=true";
import { default as indexqnpQJxUob04k5vvxDe63AnZrj12eOh_id11O3iHO_MEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/customer-center/index.vue?macro=true";
import { default as account_45cancellationmkfvRkE3W8DYClSslrHHTnlhCFKDbQIVsbO486qkxn8Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation.vue?macro=true";
import { default as _91id_9318_V68pmJf_POgav3_GK17kyh_krFd8DAHaTBkqfxOYMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupon-publishing/[id].vue?macro=true";
import { default as indexSVhZDXFUlI2QOHouGm7YYkIM0ZPCaStgpwYHihPHiaMMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupon-publishing/index.vue?macro=true";
import { default as account_45cancellation_45captcha_8B3U_V9dB936ucYUxoSIZo8y67JxihT2xtdyE9MNm4Meta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-captcha.vue?macro=true";
import { default as account_45cancellation_45completeZXrnynNBzfpgRSVHx1us_b1RnReRQZNhFk63LAggrsUMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-complete.vue?macro=true";
import { default as account_45cancellation_45phone_45verifyJGH_l9oocnqzOhAEtr2q5bnbbgzM8mK0wQMcFJ750ZEMeta } from "/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-phone-verify.vue?macro=true";
export default [
  {
    name: "main",
    path: "/main",
    meta: mainl1oJ3SknrtRhqbZZqzs4VqYAasRPWD7OCMNboDDgs1AMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/main.vue")
  },
  {
    name: "guide",
    path: "/guide",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guide.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/index.vue")
  },
  {
    name: "sample",
    path: "/sample",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/sample.vue")
  },
  {
    name: "join-pin",
    path: "/join/pin",
    meta: pinWEmdZv_eiCzR0rzSki0uRWGVtF19mTpYGl1gpnOlbpwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/pin.vue")
  },
  {
    name: "guest-pin",
    path: "/guest/pin",
    meta: pinSagMlPsgKk4qBID6zTcYnd1FQFAjiYz_zEj8GmtQDlQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/pin.vue")
  },
  {
    name: "home-free",
    path: "/home-free",
    meta: home_45free4rqqNhPa92cCEMElgctUW3j4g3PB5H3ZwjCyG_jljFcMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/home-free.vue")
  },
  {
    name: "host-link",
    path: "/host/link",
    meta: linkI35rc2NvFWfmJ5uhEE7i9ULQpd7v5m7SzmIvu3cAEBUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/host/link.vue")
  },
  {
    name: "join-plan",
    path: "/join/plan",
    meta: planGm9vgvqaQ_Qytu3i93GXFCc5WZMcbyOe0vvntAdM3dYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/plan.vue")
  },
  {
    name: "family-add",
    path: "/family/add",
    meta: addRJk0boWBi9BplpBlvAljSA7KThDzhpY1zWE_cdD43oIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/add.vue")
  },
  {
    name: "guest-link",
    path: "/guest/link",
    meta: link_DcU9fVaIYG3zLnCRD6pvydUxgSWC_AlrwzJS7dRuSQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/link.vue")
  },
  {
    name: "join",
    path: "/join",
    meta: indexgXnBpYm0cMdkUG3gNMyYuTO9SAQ8a5oOGHFk_hWCaPYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/index.vue")
  },
  {
    name: "join-terms",
    path: "/join/terms",
    meta: terms2QJhWDzMHOC_JnUG4ZjvgBg5mHswEI6tY_aU1TdUiosMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/terms.vue")
  },
  {
    name: "guest",
    path: "/guest",
    meta: indexPD2FuBVYkhXYj6A1sXwD1c2xrlL242KOrnHq2JCFiG0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/index.vue")
  },
  {
    name: "join-verify",
    path: "/join/verify",
    meta: verify3MnbpkILLivSD6GyDW0or3wEdgfuUhRNFcNfwbwCX8gMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/verify.vue")
  },
  {
    name: "lock-screen",
    path: "/lock-screen",
    meta: lock_45screenXWasmKWRIkbbm1sr4DjGjCKDeBhPJo2iVV3rBrIvjuAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/lock-screen.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexevi2pxKdpxOJMHoEu3e_xiK3aUA03bt5lsN1srzmo_oMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/login/index.vue")
  },
  {
    name: "device",
    path: "/device",
    meta: index6XuNAq_4Yb2RXweE_3RrKh_tsgozUTVE_5cp__vWRpAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/index.vue")
  },
  {
    name: "device-siren",
    path: "/device/siren",
    meta: sirennqauH_1_TXGX1l2QB9d76L_1VrdVJnF3TSQVcft_FWoMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/siren.vue")
  },
  {
    name: "family",
    path: "/family",
    meta: indexZpqw9ieO8tYKUYx4_Me_VZNCQPoMhFFG6jNPh68HC48Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/index.vue")
  },
  {
    name: "join-captcha",
    path: "/join/captcha",
    meta: captcha3UAegGqlkBl0xPycBT_Dw5AjYKE2u33tjgswk0xd4zYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/captcha.vue")
  },
  {
    name: "mypage-email",
    path: "/mypage/email",
    meta: emailJtQmVydrBBgx82hwMpS5RpT2bs3HIg4xGS0_G5A9kAgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/email.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: indexlQsVrmghc_JwGaa91zgKrkSrRnvkgNoACJDi6jmLUz8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/index.vue")
  },
  {
    name: "block-service",
    path: "/block-service",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/block-service.vue")
  },
  {
    name: "bye-telco",
    path: "/bye/:telco?",
    meta: _91_91telco_93_93gjkt8hVvgH73iE5nRpsGg2ylUGplt9_TF7WafGDIbWwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/bye/[[telco]].vue")
  },
  {
    name: "join-complete",
    path: "/join/complete",
    meta: completeEbMFu7oeX4NkoEIYbGNntuUMBchKmtr2QZWPXFrNy0AMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/complete.vue")
  },
  {
    name: "login-captcha",
    path: "/login/captcha",
    meta: captcha6Us0gyrGgx1J80l8ISHgN193XVQ_6NqGtZ_v_V8PosAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/login/captcha.vue")
  },
  {
    name: "magazine-list",
    path: "/magazine/list",
    meta: listcgc9hgcUdXO0hZcVtwx2PAwl31WXK3F0bqTgMQ45rP0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/list.vue")
  },
  {
    name: "mypage-report",
    path: "/mypage/report",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/report.vue")
  },
  {
    name: "privacyPolicy",
    path: "/privacyPolicy",
    meta: privacyPolicyr9MqsbP2Z3B7y51btfpGomUm3aSp3qne2eAgLOvC204Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/privacyPolicy.vue")
  },
  {
    name: "homepage",
    path: "/homepage",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/index.vue")
  },
  {
    name: "homepage-login",
    path: "/homepage/login",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/login.vue")
  },
  {
    name: "kcb-cert-popup",
    path: "/kcb/cert-popup",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/kcb/cert-popup.vue")
  },
  {
    name: "mypage-inquiry",
    path: "/mypage/inquiry",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/inquiry.vue")
  },
  {
    name: "device-location",
    path: "/device/location",
    meta: locationZdYGEausF5QkXna1jyTD7m1twuSBmtdfYceGYMeONwUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/location.vue")
  },
  {
    name: "join-permission",
    path: "/join/permission",
    meta: permissionzwW8_2CM_fxdgjtvA2mgSrACSh7drbpdZtEg4E6zDcwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/permission.vue")
  },
  {
    name: "mypage-policies",
    path: "/mypage/policies",
    meta: policiesL8e_F0nCXyZTdVNyaYrIElizmN6nmqbo2I_xNWlqYwwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/policies.vue")
  },
  {
    name: "guest-permission",
    path: "/guest/permission",
    meta: permissionMVGXPgnHRRERyKylcj_vdWr2vhgLd5vPfr1OXIdW37YMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/permission.vue")
  },
  {
    name: "homepage-account",
    path: "/homepage/account",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account.vue")
  },
  {
    name: "homepage-coupons",
    path: "/homepage/coupons",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/coupons.vue")
  },
  {
    name: "join-signup-free",
    path: "/join/signup-free",
    meta: signup_45freeidP2o1S9EAbhSJ9qPUIUQH6z_t8a_Yx5Ykku_yQvCR0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/signup-free.vue")
  },
  {
    name: "join-sns-connect",
    path: "/join/sns-connect",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/sns-connect.vue")
  },
  {
    name: "join-terms-agree",
    path: "/join/terms-agree",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/terms-agree.vue")
  },
  {
    name: "mypage-line-info",
    path: "/mypage/line-info",
    meta: line_45info_KoDhMD4fHZRCzzIYxIwf4z7T_42aNuusN9_VFNOKywMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/line-info.vue")
  },
  {
    name: "refund-telco",
    path: "/refund/:telco?",
    meta: _91_91telco_93_93KE3blRWs_aOwqoCM1R3BNJgcTwjPJ_3qkK__I18musIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/refund/[[telco]].vue")
  },
  {
    name: "device-block-apps",
    path: "/device/block-apps",
    meta: block_45appsQcygcsY7vXABFJaWsrDZMCtqdHg77YFaHK4Ka9686r4Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/block-apps.vue")
  },
  {
    name: "guest-invite-code",
    path: "/guest/invite-code",
    meta: invite_45codenvQ11x9SSsZqSJet_yP0jwgPMeZjUOdTrgkFCZ9DYi8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/invite-code.vue")
  },
  {
    name: "homepage-magazine",
    path: "/homepage/magazine",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/magazine.vue")
  },
  {
    name: "kcb-cert-callback",
    path: "/kcb/cert-callback",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/kcb/cert-callback.vue")
  },
  {
    name: "device-loss-status",
    path: "/device/loss-status",
    meta: loss_45statusy1lye7WrYKgUNtD9NA4sDwLC0UBD0kG_kXESlAXyJPAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/loss-status.vue")
  },
  {
    name: "join-service-intro",
    path: "/join/service-intro",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/service-intro.vue")
  },
  {
    name: "auth-apple-callback",
    path: "/auth/apple/callback",
    meta: callback2Geex_vik7B1bnzmXK6jWhwtjnPxVeCL9heJJ97UZOwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/apple/callback.vue")
  },
  {
    name: "auth-kakao-callback",
    path: "/auth/kakao/callback",
    meta: callbackx_3X9bMQPQLzBE8Gdzo_RAwi_cU7VnBPpM9HPdwz4WUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/kakao/callback.vue")
  },
  {
    name: "auth-naver-callback",
    path: "/auth/naver/callback",
    meta: callbackOzAMCpH7lDF55Ks6b1xxtyUyNUqML6hz2HjpS9uKrzEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/naver/callback.vue")
  },
  {
    name: "device-lock-message",
    path: "/device/lock-message",
    meta: lock_45messageNNz5bDcnQ2WIxJe1nLyjjH7aFunN4MT3QYlsSEgQ8k8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/lock-message.vue")
  },
  {
    name: "device-usim-history",
    path: "/device/usim-history",
    meta: usim_45historyKFz32J9KFyb73kTsfoig7_UhVeZWeoZXsGfA0_5O12QMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/usim-history.vue")
  },
  {
    name: "homepage-find-phone",
    path: "/homepage/find-phone",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/find-phone.vue")
  },
  {
    name: "mypage-cancel",
    path: "/mypage/cancel",
    meta: indexK4L2EdB7kSzwyDnJf87vOhXQPQ1BfYnpCNZ2kRGQfPAMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/cancel/index.vue")
  },
  {
    name: "auth-google-callback",
    path: "/auth/google/callback",
    meta: callbackKzujLD6k8b68zMHkLeo_Q__vQJ6nl9p_vJs1t_zKHJEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/auth/google/callback.vue")
  },
  {
    name: "homepage-email-login",
    path: "/homepage/email-login",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/email-login.vue")
  },
  {
    name: "homepage-sns-connect",
    path: "/homepage/sns-connect",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/sns-connect.vue")
  },
  {
    name: "homepage-terms-agree",
    path: "/homepage/terms-agree",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/terms-agree.vue")
  },
  {
    name: "mypage-coupons",
    path: "/mypage/coupons",
    meta: indexdIYm5G25sfOhv0_QFj2nZi55gkKRGpHkFDLQIZ601ggMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupons/index.vue")
  },
  {
    name: "homepage-phone-verify",
    path: "/homepage/phone-verify",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/phone-verify.vue")
  },
  {
    name: "mypage-insurance-form",
    path: "/mypage/insurance/form",
    meta: formetWhqedD9zi_AFUn2UyILc5jD7izghS1tcvDml6ZLnwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/form.vue")
  },
  {
    name: "device-message-history",
    path: "/device/message-history",
    meta: message_45history6A4g5N8RZzUjSNdQLHqDbme7y7ffGy_bB7UnNdHUKZIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/message-history.vue")
  },
  {
    name: "mypage-cancel-complete",
    path: "/mypage/cancel/complete",
    meta: completeODbjsDMLYEWmaV1Y1CKaR_wOxUUsqHQXfCgjhK0ie48Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/cancel/complete.vue")
  },
  {
    name: "mypage-insurance-files",
    path: "/mypage/insurance/files",
    meta: filesFkza0ow7WSbrLyHy2JGd4Jm1SG0dDD_tVZur6bGZPzIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/files.vue")
  },
  {
    name: "mypage-insurance-guide",
    path: "/mypage/insurance/guide",
    meta: guideAjr7uIqKREttVp2d_pzFHTVc5b0NvSNV6NQXCOYJq5UMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/guide.vue")
  },
  {
    name: "mypage-insurance",
    path: "/mypage/insurance",
    meta: indexxUzLw9WXDg_JVR39YqtcFNcev_CJV2X281ZkXgEEPCMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/index.vue")
  },
  {
    name: "family-familyIdx-edit",
    path: "/family/:familyIdx()/edit",
    meta: editNoRoXLem9dOUSabGUSkTSLxVEioms3srYDYVMvuizS8Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/edit.vue")
  },
  {
    name: "homepage-service-signup",
    path: "/homepage/service-signup",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/service-signup.vue")
  },
  {
    name: "mypage-insurance-detail",
    path: "/mypage/insurance/detail",
    meta: detailGShdAFTMbbxYK3Jx8JDBlf_ewxXQZhzd_9wTUocyX2gMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/detail.vue")
  },
  {
    name: "mypage-insurance-review",
    path: "/mypage/insurance/review",
    meta: reviewH9fhmOCl0RGwaXWsfsx1u0eyX_XW9R_A9V2gBhtp_FQMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/review.vue")
  },
  {
    name: "device-emergency-contact",
    path: "/device/emergency-contact",
    meta: emergency_45contactna_od4IMnDpjb3XFhfKcHoClx0zVsesja9Ntj2mKPGgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/emergency-contact.vue")
  },
  {
    name: "family-familyIdx",
    path: "/family/:familyIdx()",
    meta: indexfjUYjh3ttwWJB_mEOzVAKlOu_QxZCDLQRCcG002YlLUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/index.vue")
  },
  {
    name: "family-familyIdx-siren",
    path: "/family/:familyIdx()/siren",
    meta: sirenOlUb5tEPJLRhkFXPXjrJxHPr5_x0wLu1eD5LrCOFCEUMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/family/[familyIdx]/siren.vue")
  },
  {
    name: "homepage-signup-complete",
    path: "/homepage/signup-complete",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/signup-complete.vue")
  },
  {
    name: "join-accessibility-guide",
    path: "/join/accessibility-guide",
    meta: accessibility_45guidezq8uJ_b8_ofCB4_Abb9RIWGhpA7iTM_7nna_8MPcemwMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/join/accessibility-guide.vue")
  },
  {
    name: "mypage-insurance-history",
    path: "/mypage/insurance/history",
    meta: historyiSP_02xyuLEfH5TQF_3fsIcELMYGg8T77bQV7v3gt5kMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/history.vue")
  },
  {
    name: "guest-accessibility-guide",
    path: "/guest/accessibility-guide",
    meta: accessibility_45guide_ptTayoqW8a3OqKrBWEJCGTRRQV4ZF_yuIx__3J0UpEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/guest/accessibility-guide.vue")
  },
  {
    name: "homepage-insurance-claims",
    path: "/homepage/insurance-claims",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/insurance-claims.vue")
  },
  {
    name: "magazine-financial-detail",
    path: "/magazine/financial-detail",
    meta: financial_45detail029EL3_JK64cmDCImsnjl0Hf3mwU7PWw44xRPNsCx4cMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/financial-detail.vue")
  },
  {
    name: "mypage-insurance-complete",
    path: "/mypage/insurance/complete",
    meta: complete1YtCSNmKXQJ35NspI_MGZD5Kzzqem0Kah740c_7bUUgMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/insurance/complete.vue")
  },
  {
    name: "device-block-apps-complete",
    path: "/device/block-apps-complete",
    meta: block_45apps_45completeGXcD9lPyvEkKY3lnpIXsVVQCI21MoTz18qvrYMwkQmsMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/device/block-apps-complete.vue")
  },
  {
    name: "homepage-family-protection",
    path: "/homepage/family-protection",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/family-protection.vue")
  },
  {
    name: "mypage-coupons-couponIdx",
    path: "/mypage/coupons/:couponIdx()",
    meta: _91couponIdx_93rhrTol38rbO3sWROXQ6MGDQgSUJe5MsPwncfVugHec0Meta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupons/[couponIdx].vue")
  },
  {
    name: "homepage-emergency-contacts",
    path: "/homepage/emergency-contacts",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/emergency-contacts.vue")
  },
  {
    name: "magazine-financial-magazine",
    path: "/magazine/financial-magazine",
    meta: financial_45magazinefoxpNnEB2fMMpw1z0YQc7_x7YC1i8QziaQ4kGcQz5CIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/magazine/financial-magazine.vue")
  },
  {
    name: "mypage-customer-center-idx",
    path: "/mypage/customer-center/:idx()",
    meta: _91idx_93_JeX92TsNlQ2BJb2ZFD1XeH1EXyMBT1aa6__3camCcIMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/customer-center/[idx].vue")
  },
  {
    name: "mypage-customer-center",
    path: "/mypage/customer-center",
    meta: indexqnpQJxUob04k5vvxDe63AnZrj12eOh_id11O3iHO_MEMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/customer-center/index.vue")
  },
  {
    name: "homepage-account-cancellation",
    path: "/homepage/account-cancellation",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation.vue")
  },
  {
    name: "mypage-coupon-publishing-id",
    path: "/mypage/coupon-publishing/:id()",
    meta: _91id_9318_V68pmJf_POgav3_GK17kyh_krFd8DAHaTBkqfxOYMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupon-publishing/[id].vue")
  },
  {
    name: "mypage-coupon-publishing",
    path: "/mypage/coupon-publishing",
    meta: indexSVhZDXFUlI2QOHouGm7YYkIM0ZPCaStgpwYHihPHiaMMeta || {},
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/mypage/coupon-publishing/index.vue")
  },
  {
    name: "homepage-account-cancellation-captcha",
    path: "/homepage/account-cancellation-captcha",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-captcha.vue")
  },
  {
    name: "homepage-account-cancellation-complete",
    path: "/homepage/account-cancellation-complete",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-complete.vue")
  },
  {
    name: "homepage-account-cancellation-phone-verify",
    path: "/homepage/account-cancellation-phone-verify",
    component: () => import("/var/lib/jenkins/workspace/검수_finprotection-cli/app/pages/homepage/account-cancellation-phone-verify.vue")
  }
]